import { useBuildSignerContacts } from '../buildContactOptions';
import { Form, Formik } from 'formik';
import React from 'react';
import { SelectField, SpinnerSize } from '../../../../ui-toolkit';
import { ButtonTW } from '../../../../tailwindComponents/buttonTW/ButtonTW';
import * as yup from 'yup';
import { Show } from '../../../shared/Show';
import { SpinnerTW } from '../../../../tailwindComponents/spinnerTW/SpinnerTW';
import { ISigningAppointmentEditFormData } from '../../../../types/signingAppointment/ISigningAppointmentEditFormData';
import { buildRequest, NewSignerFormValues } from './NewSignerFormValues';
import { useSelectAppointmentFromPathParam } from '../../../../utilities/order/scheduling/useSomeAppointmentFromParam';
import { getFormDataOwnerType } from '../../../../types/order/consumer/eCreateSigningAppointmentFormDataOwnerTypes';

export interface CreateExistingPartySignerFormProps {
  onCreate: () => void;
  onSaveEditions: (formData: ISigningAppointmentEditFormData) => Promise<void>;
}

export const CreateExistingPartySignerForm = ({ onCreate, onSaveEditions }: CreateExistingPartySignerFormProps) => {
  const { appointmentFromPath } = useSelectAppointmentFromPathParam();
  const formOwnerType = appointmentFromPath
    ? getFormDataOwnerType(appointmentFromPath.ownerType, appointmentFromPath.isDigitalScheduling)
    : undefined;
  const contactOptions = useBuildSignerContacts(formOwnerType, appointmentFromPath);
  if (!appointmentFromPath) {
    return null;
  }
  const initialValues: NewSignerFormValues = { id: appointmentFromPath.id, signer: {} };

  return (
    <>
      <Formik
        initialValues={initialValues}
        onSubmit={async (values) => {
          const request = buildRequest(values);
          await onSaveEditions(request);
          onCreate();
        }}
        validationSchema={ValidationSchema}
      >
        {({ isValid, isSubmitting }) => (
          <Form>
            <div className={'flex flex-col gap-28'}>
              <SelectField
                name={'signer'}
                options={contactOptions}
                label={'Existing Order Contact'}
                placeholder={'Choose a contact'}
                isRequired
              />

              <div className={'mt-4 flex justify-end'}>
                <ButtonTW type={'submit'} disabled={!isValid}>
                  <Show when={isSubmitting} fallback={'Create'}>
                    <SpinnerTW className={'border-white'} size={SpinnerSize.small} />
                  </Show>
                </ButtonTW>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};

const ValidationSchema = yup.object().shape({
  signer: yup.object().required(),
});
